import { ReactElement } from 'react';
import { useSelector } from 'react-redux';

import RadioButton from '@components/RadioButton';
import SimpleElementSkeleton from './skeletons/SimpleElementSkeleton';
import { boolean } from 'yup';


type PaymentTypeProps = {
    id: string;
    checked: boolean;
    value: string;
    label: string;
    onChange: (e) => void;
    claim?: string;
    images: any;
    children: any;
    classes?: string;
    onClick: (e) => void;
}

const PaymentType = (props : PaymentTypeProps) : ReactElement => {

    const {
        id,
        checked,
        value,
        label,
        onChange,
        claim,
        images,
        children,
        classes,
        onClick
    } = props;

    const cart = useSelector(state => state.cart.cart);

    return(
        <>
        {!!cart ?
            <div className={`payment-type ${classes}`}>
                <div className="payment-type-header" onClick={(e) => {e.preventDefault(); onClick(value)}}>
                    <div className="payment-type-header-left">
                        <RadioButton 
                            id={id}
                            checked={checked}
                            value={value}
                            label={label}
                            onChange={(e) => onChange(e)}
                            onClick={(e) => {e.preventDefault()}}
                        />
                        {claim && 
                            <label className="payment-type-header-claim">
                                {claim}
                            </label>
                        }
                    </div>
                    <div className="payment-type-header-right">
                        {images}
                    </div>    
                </div>
                
                <div className={`payment-type-main  ${checked ? 'show' : ''}`}>
                    {children}
                </div>
            </div> :
            <SimpleElementSkeleton width={'100%'} height={'58px'} />
        }
        </>
    )
}

export default PaymentType;